import { StructureProductType } from "@ac-expo/api-types";
import { FileType } from "@prisma/client";
import { cn } from "../../../../utils";
import { ProductImageCarousel } from "../../ProductImageCarousel";

type ProductCardProps = {
  product: Pick<StructureProductType, "name" | "description" | "images" | "link">;
  getFileUrl: (key?: string, type?: FileType, width?: number) => string;
  hasProductLink?: boolean;
  canShowCarousel?: boolean;
};

export const ProductCard = ({ product, getFileUrl, hasProductLink, canShowCarousel }: ProductCardProps) => {
  const isClickable = hasProductLink && product.link;

  const cardContent = (
    <>
      <ProductImageCarousel
        images={product?.images}
        productName={product?.name}
        getFileUrl={getFileUrl}
        className="xs:w-40 flex-shrink-0 2xs:px-12 xs:px-0"
        canShowCarousel={canShowCarousel}
      />

      <div className="flex flex-col gap-2 py-2 px-4 flex-1 min-w-0">
        <h3 className="text-sm text-stone-900 font-bold">{product.name}</h3>
        {product.description && (
          <p className="text-stone-900 text-xs font-normal text-ellipsis overflow-hidden">
            {product.description}
          </p>
        )}
      </div>
    </>
  );

  const cardClassName = cn(
    "flex gap-4 rounded-xl border border-gray-200 bg-white max-md:gap-2 xs:h-40 max-xs:flex-col",
    isClickable && "cursor-pointer hover:border-primary-300 transition-colors"
  );

  if (isClickable) {
    return (
      <a
        href={product.link!}
        target="_blank"
        rel="noopener noreferrer"
        className={cardClassName}
      >
        {cardContent}
      </a>
    );
  }

  return <div className={cardClassName}>{cardContent}</div>;
};
